module.exports = __webpack_public_path__ + "img/esteeDW3.c3a18cc1.jpg";